import { z } from 'zod';
import { RuleCondition, RuleConditionZod } from './rule.condition.zod';

/**
 * One step of a stepped Creator: a label for the step header and the top-level sections it shows.
 *
 * `sections` are compiled section paths (`identity.customerDetails`, `body.details`) — the same form
 * rule targets use. `showWhen` is an ordinary rule condition; while it is false the step is skipped.
 * `status` is a bind (model or `$ctx.`) whose text the footer shows after "Step N of M" on this step.
 * `keepInHeader` keeps a skipped step in the step header as "Not needed", so the header never jumps.
 * Every top-level Creator section belongs to exactly one step, so no section is ever unreachable.
 */
export interface SurfaceStepSchema {
  readonly id: string;
  readonly label: string;
  readonly sections: string[];
  readonly showWhen?: RuleCondition;
  readonly status?: string;
  readonly keepInHeader?: boolean;
}

export const SurfaceStepSchemaZod: z.ZodType<SurfaceStepSchema> = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  sections: z.array(z.string().min(1)).min(1),
  showWhen: RuleConditionZod.optional(),
  status: z.string().min(1).optional(),
  keepInHeader: z.boolean().optional(),
}).strict();
